import OptionConst from "@/const/Option";
import { DakokuService } from "@/service/DakokuService";
import { GetKinmuListRes, HakenDakokuData, KinmuListInfo, KinmuListData } from "@/types/Dakoku";
import { computed, ref, Ref } from "vue";
import { timeToHHmm } from "@/filters/common";

/*
 * 勤務一覧
 */
export function useKinmuList() {
  let loading = ref(0)
  let isError = ref(false)
  const sumKinmuTime = ref('');
  const kinmuListData: Ref<GetKinmuListRes | null> = ref(null)
  const kinmuListInfo: Ref<KinmuListInfo> = ref(new KinmuListInfo());
  const kinmuListSelectSyouninData: Ref<KinmuListData[]> = ref([]) // 承認の選択をした打刻レコードの行数を返す用
  const dakokuService = new DakokuService()

  // 指定期間の勤務一覧を取得する
  const getKinmuList = async (year: number | null, month: number | null, syuugyouBasyoId: number, koyouKeiyakuId: number | null | undefined, targetUserId: number, dakokuId?: number | null) => {
    return await dakokuService.getKinmuList(year, month, syuugyouBasyoId, koyouKeiyakuId, targetUserId, dakokuId)
  }
  const loadKinmuList = async (year: number | null, month: number | null, syuugyouBasyoId: number, koyouKeiyakuId: number | null | undefined, targetUserId: number, dakokuId?: number | null) => {
    loading.value++
    kinmuListData.value = await getKinmuList(year, month, syuugyouBasyoId, koyouKeiyakuId, targetUserId, dakokuId)
    if (!kinmuListData.value) {
      loading.value--
      return
    }

    // 承認の選択をした打刻レコードの行数を返す用
    kinmuListSelectSyouninData.value = kinmuListData.value.list

    kinmuListInfo.value.syuugyouBasyo = kinmuListData.value.syuugyouBasyo
    if (kinmuListInfo.value.syuugyouBasyo && kinmuListData.value.syuugyouBasyo) {
      kinmuListInfo.value.syuugyouBasyo.koyou_id = kinmuListData.value.syuugyouBasyo.koyou_id
    }
    kinmuListInfo.value.userId = kinmuListData.value.userId
    kinmuListInfo.value.year = kinmuListData.value.year
    kinmuListInfo.value.month = kinmuListData.value.month
    kinmuListInfo.value.start = kinmuListData.value.start
    kinmuListInfo.value.end = kinmuListData.value.end
    kinmuListInfo.value.userName = kinmuListData.value.userName
    kinmuListInfo.value.staffCode = kinmuListData.value.staffCode
    kinmuListInfo.value.dakokuSyouninGroupId = kinmuListData.value.dakokuSyouninGroupId
    kinmuListInfo.value.hasUncompleteDakoku = kinmuListData.value.hasUncompleteDakoku
    kinmuListInfo.value.hasWaitShinsei = kinmuListData.value.hasWaitShinsei
    kinmuListInfo.value.syozokuInfo = kinmuListData.value.syozokuInfo
    kinmuListInfo.value.meijisyoInfo = kinmuListData.value.meijisyoInfo

    await convertHakenKinmuList()
    loading.value--
  }

  const convertHakenKinmuList = async () => {
    if (!kinmuListData.value) {
      return
    }

    // 派遣先打刻に総務が編集した内容
    let hakenModInfos = kinmuListData.value.hakenModifies;

    let tmpHour = 0;
    let tmpMinute = 0;

    let tmpModifyHour = 0;
    let tmpModifyMinute = 0;

    kinmuListData.value.list.forEach(function (value) {

      let dateKey = value.key;

      // 勤務時間を設定
      if (value.kinmus.length !== 0) {
        let syoteiWorkTimes = "";

        value.kinmus.forEach(function (val) {
          syoteiWorkTimes = (val.syotei_work_times !== undefined && val.syotei_work_times !== null)
            ? val.syotei_work_times
            : '';


          if (val.modifiedKinmuTimes === undefined || val.modifiedKinmuTimes === "") {
            val.modifiedKinmuTimes = syoteiWorkTimes;

            if (val.modifiedKinmuTimes !== "") {
              let tmpModifyTime = val.modifiedKinmuTimes.split(":");
              tmpModifyHour += parseInt(tmpModifyTime[0], 10);
              tmpModifyMinute += parseInt(tmpModifyTime[1], 10);
            }
          }

          if (syoteiWorkTimes != "") {
            let tmpTime = syoteiWorkTimes.split(":");
            tmpHour += parseInt(tmpTime[0], 10);
            tmpMinute += parseInt(tmpTime[1], 10);
          }

          // 派遣先打刻に総務が編集した内容を設定
          let hakenInfoItem = hakenModInfos.filter((v: any) => v.key === dateKey);
          if (hakenInfoItem.length !== 0) {

            val.soumu_note1 = hakenInfoItem[0].soumu_note1 == null ? "" : hakenInfoItem[0].soumu_note1;
            val.soumu_note2 = hakenInfoItem[0].soumu_note2 == null ? "" : hakenInfoItem[0].soumu_note2;
          }

          // フォーマット
          val.kyuukei_times = timeToHHmm(val.kyuukei_times);
          val.syotei_work_times = timeToHHmm(val.syotei_work_times);
          val.houteinai_zangyou_times = timeToHHmm(val.houteinai_zangyou_times);
          val.jikangai_work_times = timeToHHmm(val.jikangai_work_times);
          val.shinya_warimashi_times = timeToHHmm(val.shinya_warimashi_times);
          val.chikoku_times = timeToHHmm(val.chikoku_times);
          val.soutai_times = timeToHHmm(val.soutai_times);
          val.yuukyuu_times = timeToHHmm(val.yuukyuu_times);
        });

      }

      // 勤務データがない場合、空データを設定
      if (value.kinmus.length === 0) {
        let data = <HakenDakokuData>({});

        // 派遣先打刻に総務が編集した内容を設定
        let hakenInfoItem = hakenModInfos.filter((v: any) => v.key === dateKey);
        if (hakenInfoItem.length !== 0) {

          data.soumu_note1 = hakenInfoItem[0].soumu_note1 == null ? "" : hakenInfoItem[0].soumu_note1;
          data.soumu_note2 = hakenInfoItem[0].soumu_note2 == null ? "" : hakenInfoItem[0].soumu_note2;
        }
        // data.soumu_note1 = "";
        // data.soumu_note2 = "";
        data.modifiedKinmuTimes = "";

        value.kinmus.push(data);
        // value.kinmus[0].currentModify = hakenInfoItem;
      }
    });

    tmpHour += Math.trunc(tmpMinute / 60);
    tmpMinute = tmpMinute % 60; // 剰余
    sumKinmuTime.value = tmpHour + ':' + ('0' + tmpMinute).slice(-2);
  }

  // 読み込み中か判断する
  const isLoading = computed(() => {
    console.log('isLoading', isLoading.value)
    return !(loading.value === 0 || isError.value)
  })

  const dakokuSyouninStatus = (statusId: number) => {
    const status = OptionConst.DAKOKU_SYOUNIN_STATUS_OPTION.find(item => item.val === statusId)
    if (status) {
      return status.label
    } else {
      return '-'
    }
  }

  const getKinmuListInfoByDakokuId = async (dakokuId: number | null) => {
    const res = await dakokuService.getKinmuListInfoByDakokuId(dakokuId);
    console.log('getKinmuListInfoByDakokuId', res)
    if (!res) {
      kinmuListInfo.value = new KinmuListInfo()
    } else {
      kinmuListInfo.value = res
    }
  }

  // 打刻承認を一括登録します
  const ikkatsuSyounin = async (params: number[]) => {
    const res = await dakokuService.ikkatsuSyounin(params);
    console.log('ikkatsuSyounin', res)
  };

  return {
    isLoading,
    sumKinmuTime,
    kinmuListData,
    kinmuListInfo,
    kinmuListSelectSyouninData,
    getKinmuList,
    loadKinmuList,
    dakokuSyouninStatus,
    getKinmuListInfoByDakokuId,
    ikkatsuSyounin
  }
}
